import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5f800dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]

import {ref} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CopyToClipboard',
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as {
  text: string,
}



const copy = ref()

const onClick = () => {
  copy.value.focus()
  copy.value.select()

  try {
    document.execCommand('copy')
  } catch (e) {
    //
  }

  copy.value.blur()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", { onClick: onClick }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("textarea", {
      ref_key: "copy",
      ref: copy,
      value: props.text
    }, null, 8, _hoisted_1)
  ], 64))
}
}

})